(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    // Distinguish a real click from a drag-end so the link only fires when the
  // user didn't actually swipe the slideshow.
  document.addEventListener('pointerdown', (e) => {
    const link = e.target.closest('.slide__image-link');
    if (!link) return;
    const startX = e.clientX;
    const startY = e.clientY;

    link.addEventListener('click', (ce) => {
      const dx = Math.abs(ce.clientX - startX);
      const dy = Math.abs(ce.clientY - startY);
      if (dx > 6 || dy > 6) ce.preventDefault();
    }, { once: true });
  });
  } catch(e) { console.error(e); }
})();

})();
